import { makeAutoObservable } from "mobx"

export default class DraftShareAsset {

  constructor(asset = {}) {
    this.id = asset.id
    this.position = asset.position || 0
    this.file_name = asset.file_name
    this.url = asset.url
    this.file_type = asset.file_type

    makeAutoObservable(this)
  }
}
